module.exports = __webpack_public_path__ + "img/weddingRingsMorningGlow-emotion-04@2x.1f1fdb1.webp";